/* eslint-disable react/no-array-index-key */
import styled from "@emotion/styled";
import React from "react";
import { isInsideWebView } from "src/pageDefinitions/goto/utils";

const LinkText = styled.span`
  color: -webkit-link;
  cursor: pointer;
  text-decoration: underline;
`;

export default function RichText({
  translatedParts,
  className,
}: {
  translatedParts: ({ link: string; linkText: string } | string)[];
  className?: string;
}) {
  const handleClick = (link: string) => {
    const deeplink = `${link}?openInExternalApp=true`;
    window.open(deeplink, "_system");
  };
  return (
    <p className={className}>
      {translatedParts.map((part, idx) => {
        if (typeof part === "object") {
          return isInsideWebView() ? (
            // eslint-disable-next-line jsx-a11y/no-static-element-interactions
            <LinkText
              key={idx}
              onClick={() => handleClick(part.link)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleClick(part.link);
                }
              }}
            >
              {part.linkText}
            </LinkText>
          ) : (
            <a key={idx} href={part.link}>
              {part.linkText}
            </a>
          );
        }
        return <span key={idx}>{part}</span>;
      })}
    </p>
  );
}
